import React from 'react'
import { Link } from 'react-router-dom'
import { Breadcrumb as AntBreadcrumb, Icon } from 'antd'

const Breadcrumb = ({ match, ...props }) => {
  // แยก path ออกเป็น segments
  const pathSnippets = match.path
    .split('/')
    .filter(segment => segment && !segment.startsWith(':'))

  return (
    <AntBreadcrumb {...props}>
      <AntBreadcrumb.Item key="breadcrumb-home">
        <Link to="/">
          <Icon type="home" />
        </Link>
      </AntBreadcrumb.Item>

      {pathSnippets.map((segment, index) => {
        const isLast = index === pathSnippets.length - 1
        const url = `/${pathSnippets.slice(0, index + 1).join('/')}`.replace(
          ' ',
          '_',
        )

        return (
          <AntBreadcrumb.Item key={`breadcrumb-${segment}`}>
            {isLast ? (
              segment.replace(/_/g, ' ')
            ) : (
              <Link to={url}>{segment.replace(/_/g, ' ')}</Link>
            )}
          </AntBreadcrumb.Item>
        )
      })}
    </AntBreadcrumb>
  )
}

export default Breadcrumb
